/* eslint-disable */
// Portable validation rules for productAddButtonForm.
// - Browser: attaches to window.themeCustomValidationRules
// - Node/tests: module.exports

(function (root, factory) {
  if (typeof module !== "undefined" && module.exports) {
    module.exports = factory();
  } else {
    root.themeCustomValidationRules = factory();
  }
})(typeof window !== "undefined" ? window : globalThis, function () {
  function belongsToForm(el, form) {
    if (!form) return true;
    if (!el) return false;
    try {
      if ("form" in el && el.form) return el.form === form;
    } catch (e) {
      // fall through
    }
    return false;
  }

  function filterByForm(list, form) {
    const arr = Array.isArray(list) ? list : Array.from(list || []);
    if (!form) return arr;
    return arr.filter((el) => belongsToForm(el, form));
  }

  function syncCustomOrderDataHiddenValues(scope, options) {
    const opts = options || {};
    const form = opts.form || null;
    const rootScope = scope && typeof scope.querySelectorAll === "function" ? scope : null;
    if (!rootScope) return;

    const hiddenInputs = filterByForm(
      rootScope.querySelectorAll("[data-custom-order-data-hidden]"),
      form
    );
    if (!hiddenInputs || !hiddenInputs.length) return;

    hiddenInputs.forEach((hidden) => {
      if (!hidden || hidden.disabled) return;
      const key =
        typeof hidden.getAttribute === "function"
          ? hidden.getAttribute("data-custom-order-data-hidden")
          : null;
      if (!key) return;

      const radios = filterByForm(
        rootScope.querySelectorAll(`[data-custom-order-data-radio="${key}"]`),
        form
      );
      if (!radios || !radios.length) return;

      let selectedValue = "";
      radios.forEach((radio) => {
        if (radio && radio.checked) selectedValue = radio.value || "";
      });

      if (!selectedValue) {
        const fallback =
          typeof hidden.getAttribute === "function"
            ? hidden.getAttribute("data-custom-order-data-default")
            : null;
        if (fallback) selectedValue = fallback;
      }

      if (selectedValue) hidden.value = selectedValue;
    });
  }

  function resolveFirstMatching(scope, selector, form) {
    if (!scope) return null;
    if (form && typeof scope.querySelectorAll === "function") {
      const matches = filterByForm(scope.querySelectorAll(selector), form);
      return matches && matches.length ? matches[0] : null;
    }
    if (typeof scope.querySelector === "function") {
      return scope.querySelector(selector);
    }
    if (typeof scope.querySelectorAll === "function") {
      const list = scope.querySelectorAll(selector);
      return list && list.length ? list[0] : null;
    }
    return null;
  }

  function syncRadioHiddenValues(scope, radioSyncConfig, options) {
    const opts = options || {};
    const form = opts.form || null;
    const cfgs = Array.isArray(radioSyncConfig) ? radioSyncConfig : [];
    cfgs.forEach((cfg) => {
      const hidden = resolveFirstMatching(scope, cfg.hiddenSelector, form);
      if (!hidden || hidden.disabled) return;
      const radios = scope && scope.querySelectorAll ? scope.querySelectorAll(cfg.radioSelector) : [];
      const scopedRadios = filterByForm(radios, form);
      if (!scopedRadios || !scopedRadios.length) return;

      let selectedValue = "";
      scopedRadios.forEach((radio) => {
        if (radio && radio.checked) {
          selectedValue = radio.value || "";
        }
      });

      if (!selectedValue && cfg.defaultValue) {
        const defaultRadio = Array.from(scopedRadios).find(
          (r) =>
            (r && r.value ? String(r.value) : "").toLowerCase() ===
            String(cfg.defaultValue).toLowerCase()
        );
        selectedValue = (defaultRadio && defaultRadio.value) || cfg.defaultValue;
      }

      if (selectedValue) {
        hidden.value = selectedValue;
      }
    });
  }

  function validateRequiredInputs(requiredInputs, options) {
    const opts = options || {};
    const inputs = Array.isArray(requiredInputs) ? requiredInputs : [];
    const hasFocusedError =
      typeof opts.hasFocusedError === "function" ? opts.hasFocusedError : () => false;

    let hasError = false;
    let firstErrorElement = null;
    let firstErrorScrollTarget = null;

    inputs.forEach((input) => {
      const value = input && typeof input.value === "string" ? input.value : String(input && input.value ? input.value : "");
      const isMissing = !value.trim();
      if (isMissing) {
        hasError = true;
        if (!firstErrorElement) {
          firstErrorElement = input;
          firstErrorScrollTarget =
            (input && typeof input.closest === "function" && input.closest(".item_properties")) || input;
        }
        if (input && input.style) {
          input.style.borderColor = "#ff4500";
        }
        if (input && input.classList && !hasFocusedError()) {
          input.classList.add("focused-error");
        }
      } else {
        if (input && input.style) {
          input.style.borderColor = "#aaa";
        }
        if (input && input.classList) {
          input.classList.remove("focused-error");
        }
      }
    });

    return { hasError, firstErrorElement, firstErrorScrollTarget };
  }

  function validateSpecificField(documentRef, selector, errorTextId, options) {
    const doc = documentRef;
    if (!doc || typeof doc.querySelector !== "function") {
      return { hasError: false, firstErrorElement: null, firstErrorScrollTarget: null };
    }

    const opts = options || {};
    const form = opts.form || null;
    const element =
      form && typeof doc.querySelectorAll === "function"
        ? (filterByForm(doc.querySelectorAll(selector), form)[0] || null)
        : doc.querySelector(selector);
    const errorRoot =
      element && typeof element.closest === "function" ? element.closest(".product-properties") : null;
    const errorText =
      errorRoot && typeof errorRoot.querySelector === "function"
        ? errorRoot.querySelector(errorTextId)
        : doc.querySelector(errorTextId);

    if (element && !element.disabled && !String(element.value || "").trim()) {
      if (errorText && errorText.style) {
        errorText.style.display = "block";
      }
      return {
        hasError: true,
        firstErrorElement: element,
        firstErrorScrollTarget:
          errorText ||
          (typeof element.closest === "function" && element.closest(".item_properties")) ||
          element,
      };
    }

    if (errorText && errorText.style) {
      errorText.style.display = "none";
    }

    return { hasError: false, firstErrorElement: null, firstErrorScrollTarget: null };
  }

  return {
    syncCustomOrderDataHiddenValues,
    syncRadioHiddenValues,
    validateRequiredInputs,
    validateSpecificField,
  };
});
